import { Injectable } from '@angular/core';
import { ActHttpService, HeaderTypes } from '../act-http/act-http.service';
import { PromotionCodeActiveListRequest, PromotionCodeActiveListResponse, ValidatePromotionCodeRequest } from './model/promotion-code.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class PromotionCodeService {

  constructor(
    private actHttp: ActHttpService,
  ) { }

  getPromotionCodeActiveList(request: PromotionCodeActiveListRequest): Observable<PromotionCodeActiveListResponse> {
    const url = environment.endpoint.getPreBookingPromotionCodeList;
    return this.actHttp.post(url, request, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)).map((res) => res.json().data);
  }

  validatePromotionCode(request: ValidatePromotionCodeRequest) {
    const url = environment.endpoint.preBookingValidatePromotionCode;
    return this.actHttp.post(url, request, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)).map((res) => res.json().data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/promotion-code/promotion-code.service.ts